import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'WebSourceManagement',
  methods: {
    createWebSource: function createWebSource() {
      this.$router.push({
        name: 'web-source-create'
      });
    },
    navigateToOverview: function navigateToOverview() {
      this.$router.push({
        name: 'web-source-management'
      });
    }
  },
  data: function data() {
    return {
      routerKey: 0
    };
  },
  computed: {
    isInOverview: function isInOverview() {
      return this.$route.name === 'web-source-management';
    }
  },
  watch: {
    $route: function $route(to, from) {
      // Reset component when going from webSource creation to editing (to force props to update)
      if (from.name === 'web-source-create' && to.name === 'web-source-edit') {
        this.routerKey++;
      }
    }
  }
};